import { useFormStepper } from "@/components/FormStepper/FormStepper.context"
import { useStyles } from "@/components/FormStepper/FormStepper.styles"
import { Step } from "@/components/FormStepper/Step/Step"
import React from "react"
import { UseFormReturn } from "react-hook-form"
export interface StepInfo<T = any> {
    id: string
    components: React.FC<T>[]
    name: string
    title: string
    description: string
    onIn?: (({
        actualStep,
        ...rest
    }: { actualStep?: number } & UseFormReturn<any, any, unknown>) => boolean | void | Promise<boolean | void>)[]
    onOut?: (({
        actualStep,
        ...rest
    }: { actualStep?: number } & UseFormReturn<any, any, unknown>) => boolean | Promise<boolean>)[]
}
interface FormStepperProps {
    enableNextStep?: boolean
    enableAllSteps?: boolean
}

export const FormStepper = ({ enableNextStep = true, enableAllSteps = false }: FormStepperProps) => {
    const { classes } = useStyles()
    const { actualStep, toStep, steps } = useFormStepper()

    const getStepIsDisabled = (stepIndex: number): boolean => {
        if (enableAllSteps) return false
        if (actualStep + 1 === stepIndex) return !enableNextStep
        return actualStep < stepIndex
    }

    return (
        <div className={classes.container}>
            {steps.map((step, i) => (
                <Step
                    isLastStep={steps.length - 1 === i}
                    key={i}
                    label={step.name}
                    step={i}
                    handleClick={toStep}
                    disabled={getStepIsDisabled(i)}
                    isConcluded={actualStep > i}
                    isActive={actualStep === i}
                />
            ))}
        </div>
    )
}
